export const availableDates = state => state.getIn(['availableDates', 'entities']);
export const availableDateById = (state, id) => availableDates(state).get(String(id));
export const availableDatesByIds = (state, ids) => ids.map(id => availableDateById(state, id));
